export const LEGACY_PERPAY_PLUS = 'perpay_plus';
export const PERPAY_PLUS = 'perpay_plus_v2';
export const CARD = 'card';
export const CARD_AUTO_APPLY = 'card_auto_apply';
